export function getColor(alphabet) {
    let upperCaseAlphabet = alphabet.toUpperCase();
    const alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    const colors = ['#FF8271', '#FF8660', '#FFAC60', '#E4B845', '#D7BB73', '#C9BC4A', '#C8DA5A', '#3FD7BB', '#57E8CE', '#42E0F5', '#9A9DE4', '#BCBEF3', '#C0A7F3', '#BB9BFF', '#BF9EE0', '#CE7AC6', '#D79CD1', '#D79CAD', '#EEA8BD', '#FF8DAF', '#DC86A0', '#DC8686', '#F19090', '#FF9D9D', '#FA8C8C', '#DF8181']
    for (let i = 0; i < 25; i++) {
        if (alphabets[i] === upperCaseAlphabet) {
            return colors[i];
        }
    }
    return '#005cb2'
}